import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PlanService from "../../services/plan.service";


export const getPlans = createAsyncThunk(
  "plan/getPlans",
  async (params, thunkAPI) => {
    try {
      const response = await PlanService.getPlan(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =========================
   Get My Active Plan
========================= */
export const getMyPlan = createAsyncThunk(
  "plan/getMyPlan",
  async (params, thunkAPI) => {
    try {
      const response = await PlanService.getMyPlan(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,

  // All available plans
  planslist: [],

  // User's current subscription
  myPlan: null,
  myPlanLoading: false,
  myPlanError: null,

  updateSuccess: false,
};

const planSlice = createSlice({
  name: "plan",
  initialState,

  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },

    clearMyPlan: (state) => {
      state.myPlan = null;
      state.myPlanError = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* =========================
         Get All Plans
      ========================= */
      .addCase(getPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.planslist = action.payload?.data || [];
      })

      .addCase(getPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* =========================
         Get My Plan
      ========================= */
      .addCase(getMyPlan.pending, (state) => {
        state.myPlanLoading = true;
        state.myPlanError = null;
      })

      .addCase(getMyPlan.fulfilled, (state, action) => {
        state.myPlanLoading = false;

        // API returns data: null when user has no active plan
        state.myPlan = action.payload?.data || null;
      })

      .addCase(getMyPlan.rejected, (state, action) => {
        state.myPlanLoading = false;
        state.myPlanError = action.payload;
        state.myPlan = null;
      });
  },
});

export const {
  resetUpdateStatus,
  clearMyPlan,
} = planSlice.actions;

export default planSlice.reducer;